module.exports = __webpack_public_path__ + "static/media/one-core-palette-comparison.e1eb2418.gif";